// actions/types.ts
export const SET_SWING_RESULTS = 'SET_SWING_RESULTS';
